document.addEventListener("DOMContentLoaded", () => {
  const productBtns = document.querySelectorAll(".product-form-top__btn");
  const productPopups = document.querySelectorAll(".product-popup");

  if (productBtns[0]) {
    productBtns.forEach((btn, i) => {
      btn.addEventListener("click", () => {
        closePopup()
        productPopups[i].classList.add("product-popup--show")
      })
    })
  }

  function closePopup() {
    productPopups.forEach((popup) => {
      popup.classList.remove("product-popup--show")
    })
  }

  const popupProduct = document.querySelectorAll(".product-popup");
  const popupProductClose = document.querySelectorAll(".product-popup__close");

  if (popupProduct[0]) {
    popupProductClose.forEach((item, i) => {
      item.addEventListener("click", () => {
        console.log("close");
        closePopup()
        // popupProduct[i].classList.remove("product-popup--show")
      })
    })
  }

  const searchInputs = document.querySelectorAll(".product-popup__search");
  if (!searchInputs.length) return;

  // нормалізує стрічку: lowercase + прибирає пробіли, пунктуацію та символи
  function normalizeForSearch(str) {
    return String(str || '')
      .toLowerCase()
      .normalize('NFKD')           // розклад діакритики (надійніше)
      .replace(/[\p{P}\p{S}\s]+/gu, ''); // прибирає пунктуацію, символи, пробіли (u-флаг + Unicode props)
  }

  searchInputs.forEach(searchInput => {
    // делегуємо на конкретний попап
    searchInput.addEventListener("input", function () {
      const popup = this.closest(".product-popup");
      if (!popup) return;

      const rawQuery = this.value.trim();
      const q = normalizeForSearch(rawQuery);

      const cols = popup.querySelectorAll(".product-popup__col");
      if (cols.length < 2) return;

      const breedCells = cols[0].querySelectorAll(".product-popup__cell:not(:first-child)");
      const sizeCells = cols[1].querySelectorAll(".product-popup__cell:not(:first-child)");

      let anyVisible = false;

      breedCells.forEach((cell, i) => {
        const breedText = (cell.textContent || "").trim();
        const sizeText = (sizeCells[i]?.textContent || "").trim();

        const breedNorm = normalizeForSearch(breedText);
        const sizeNorm = normalizeForSearch(sizeText);

        // Логіка матчу: якщо нормалізована строка містить запит — вважаємо збіг
        const isMatch = (
          q === "" || // порожній запит — показуємо все
          breedNorm.includes(q) ||
          sizeNorm.includes(q) ||
          // ще залишимо "класичний" contains на оригінальних текстах на випадок специфіки
          breedText.toLowerCase().includes(rawQuery.toLowerCase()) ||
          sizeText.toLowerCase().includes(rawQuery.toLowerCase())
        );

        if (isMatch) {
          cell.style.display = "";
          if (sizeCells[i]) sizeCells[i].style.display = "";
          anyVisible = true;
        } else {
          cell.style.display = "none";
          if (sizeCells[i]) sizeCells[i].style.display = "none";
        }
      });
    });
  });

  document.querySelectorAll('.box-hint__text').forEach(el => {
    el.innerHTML = el.textContent.replace(/€/g, '<span class="text-montserrat">&nbsp; €</span>');
  });

  const configuratorButton = document.querySelector(".configurator-button")
  const configuratorButtonClose = document.querySelector(".configurator-button__close")

  if (configuratorButton) {
    configuratorButtonClose.addEventListener("click", () => {
      configuratorButton.classList.add("configurator-button--hide")
    })
  }

  const el = document.querySelector('.shipping-info-item:first-of-type .shipping-info-item-title');

  // Отримуємо сьогоднішню дату
  const today = new Date();

  // Додаємо 1 день
  const firstDayDate = new Date(today);
  firstDayDate.setDate(today.getDate() + 1);

  // Додаємо ще 1 день для другого числа
  const secondDayDate = new Date(firstDayDate);
  secondDayDate.setDate(firstDayDate.getDate() + 1);

  // Місяці у скороченому форматі
  const monthNamesPt = [
    "jan", "fev", "mar", "abr", "mai", "jun",
    "jul", "ago", "set", "out", "nov", "dez"
  ];

  const firstDay = firstDayDate.getDate();
  const secondDay = secondDayDate.getDate();

  // Якщо другий день у новому місяці — показуємо обидва місяці
  let text;
  if (firstDayDate.getMonth() === secondDayDate.getMonth()) {
    text = `${firstDay} - ${secondDay} ${monthNamesPt[firstDayDate.getMonth()]}.`;
  } else {
    text = `${firstDay} ${monthNamesPt[firstDayDate.getMonth()]}. - ${secondDay} ${monthNamesPt[secondDayDate.getMonth()]}.`;
  }

  // Оновлюємо текст
  el.textContent = text;


  const button = document.querySelector('.configurator-button__link');

  if (!button) return;

  button.addEventListener('click', (e) => {
    e.preventDefault(); // блокуємо миттєвий перехід

    // Отримуємо всі дата-атрибути
    localStorage.setItem('productIndex', button.getAttribute("data-product-index"));
    localStorage.setItem('colorIndex', button.getAttribute("data-color-index"));

    // Після запису переходимо на сторінку
    window.location.href = button.getAttribute('href');

  })

  setTimeout(() => {
    const btnBundlePrice = document.querySelector(".box-hint__price");
    const btnBundlePriceDiscount = document.querySelector(".box-hint__price-discount");
  
    btnBundlePrice.textContent = document.querySelector(".bundle-result__total-old-price").textContent;
    btnBundlePriceDiscount.textContent = document.querySelector(".bundle-result__total-new-price").textContent;
  }, 1000);
})

